module.exports = "<template> <h1>Buchungsmaske</h1> <div id=sio-toma-mask></div> </template> ";